export default __webpack_public_path__ + "ce18a5009b96fa18834d1bf354ddbbb5.svg";